import { createWebHistory, createRouter } from 'vue-router';

import IndexView from '@/views/IndexView.vue';
import SignInView from './views/SignInView.vue';

const routes = [  
  { path: '/', component: IndexView },
  { path: '/signin', component: SignInView }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;